import Immutable from 'immutable';

const UnitQuizSkillResultRecord = Immutable.Record({
  skill: undefined,
  score: undefined,
  totalScore: undefined,
});

class UnitQuizSkillResult extends UnitQuizSkillResultRecord { }

export default UnitQuizSkillResult;



// WEBPACK FOOTER //
// ./data/UnitQuiz/model/UnitQuizResult/UnitQuizSkillResult/model.js